export const Target = {
    SbRo: 'SB_RO',
    SbPl: 'SB_PL',
    SbRs: 'SB_RS',
    NgBe: 'NG_BE',
    SbCom: 'SB_COM',
    SbBr: 'SB_BR',
    SbOther: 'SB_OTHER', // TODO: remove due to deprecation!
} as const;
export type Target = typeof Target[keyof typeof Target];
